export enum BenchTypes
{
    RAW = 'raw',
    TRAINING = 'training',
    MARKETING = 'marketing',
    PLACEMENT = 'placement',
    DECLIENED = 'declined',
    SALESREP = 'salesRep'
}
export interface IBenchEmployee
{
    benchEmployeeId: string;

    orgId: string;

    accountManagerId: string;
    accountManagerName?: string;

    technology: string;

    benchStatus: string;


    priority: string;

    salesRepId: string;
    salesRepFullName: string;

    employmentAuthorization: string;

    firstName: string;
    middleName?: string;
    lastName: string;
    dateOfBirth: Date;
    fullName?: string;
    emailAddress: string;
    alternateEmailAddress: string;
    mobile: string;
    homePhone: string;

    workEmailAddress: string;
    workPhone: string;

    marketingStartDate?: Date;
    placementDate?: Date;
    dateOfBenchOnBoard?: Date;
    dateOfTrainingStart?: Date;
    dateOfTrainingEnd?: Date;

    marketingStartDateToString: string;
    placementDateToString: string;
    dateOfBenchOnBoardToString: string;
    dateOfTrainingStartToString: string;
    dateOfTrainingEndToString: string;

    sex: string;
    active: boolean;
    isThirdPartyCandidate: boolean;
    comments: string;
    clientTimeStamp: string;

    benchEmployeeResume?: IBenchEmployeeDocument[];
    benchEmployeeSubmission?: IBenchEmployeeSubmission[];
    benchEmployeeStatusTracking?: IBenchEmployeeStatusTracking[];
    benchEmployeeSalesRepTracking?: IBenchEmployeeSalesRepTracking[];

}

export interface IBenchEmployeeStatusTracking
{
    benchStatus: string;
    marketingStartDate: Date;
    placenentDate: Date;

    createdDateTime: Date;
    benchEmployeeStatusTrackingId: string;
}

export interface IBenchEmployeeSalesRepTracking
{
    salesRepFullName: string;
    createdDateTime: Date;
    benchEmployeeSalesRepTrackingId: string;
}

export interface IBenchSearchResponse
{
    benchEmployees?: IBenchEmployee[];
    benchLeads?: IBenchLead[];
    success: boolean;
 }

export interface IBenchEmployeeResponse
{
    benchEmployees?: IBenchEmployee[];
    benchEmployee?: IBenchEmployee;
    benchEmployeeSubmission?: IBenchEmployeeAcceptedSubmission[];

    success: boolean;
    benchEmployeeId?: string;
}

export interface IBenchLead
{
    benchLeadId: string;
    orgId: string;
    technology: string;
    employmentAuthorization: string;

    firstName: string;
    middleName?: string;
    lastName: string;
    fullName?: string;
    emailAddress: string;
    alternateEmailAddress: string;
    mobile: string;
    homePhone: string;

    sex: string;
    active: boolean;
    isThirdPartyCandidate: boolean;
    comments: string;
    clientTimeStamp: string;
}
export interface INewBenchLeadBulk 
{
    orgId: string;

    files: File;
    clientTimeStamp?: string;

}

export interface IBenchLeadResponse
{
    benchLeads?: IBenchLead[];
    benchLead?: IBenchLead;

    success: boolean;
    message?: string;
    benchLeadId?: string;
}

export interface IBenchInterviewResponse
{
    benchInterviews?: IBenchEmployeeInterviewSchedule[];
    success: boolean;
}

export interface IBenchEmployeeDocument
{
    benchEmployeeResumeId: string;
    BenchEmployeeDocumentType: string;
    fileLocationPath: string;
    fileName: string;
}

export interface INewBenchEmployeeDocument
{
    benchEmployeeId: string;
    orgId?: string;

    files: File[];
}

export interface IBenchEmployeeInterviewData extends IBenchEmployeeInterview
{

}

export interface IBenchEmployeeSubmission
{
    benchEmployeeSubmissionId: string;
    benchEmployeeStageSubmissionId: string;

    benchEmployeeId: string;
    orgId: string;
    userId: string;
    salesRepId: string;
    submissionStatus: string;

    benchSubmissionCode: string;

    firstVendorName: string;
    firstVendorEmailAddress: string;
    primaryVendorEmailAddress: string;

    firstVendorMobile: string;
    primaryVendorMobile: string;

    clientName: string;
    rate: number;

    technology: string;
    submissionDate: Date;
    submissionAcceptedDate: Date;

    salesRepFullName?: string;
    notes: string;
    benchEmployeeInterview?: IBenchEmployeeInterview[];
    clientTimeStamp: string;
}

export interface IBenchEmployeeAcceptedSubmission
{
    benchEmployeeSubmissionId: string;
    benchEmployeeId: string;
    benchEmployeeName: string;

    orgId: string;
    userId: string;
    salesRepId: string;
    submissionStatus: string;

    benchSubmissionCode: string;

    firstVendorName: string;
    firstVendorEmailAddress: string;
    primaryVendorEmailAddress: string;

    firstVendorMobile: string;
    primaryVendorMobile: string;

    clientName: string;
    rate: number;

    technology: string;

    clientTimeStamp: string;
}
export interface IBenchEmployeeInterview
{
    benchEmployeeInterviewId: string;
    benchEmployeeId: string;
    orgId: string;

    interviewType: string;
    interviewRepId?: string;

    interviewStatus: string;

    scheduledDateTime: Date;
    feedBack: string;

    clientTimeStamp: string;
    scheduledDateTimeToString: string;
}

export interface IBenchEmployeeInterviewSchedule
{
    benchEmployeeInterviewId: string;
    benchEmployeeId: string;

    benchSubmissionCode: string;
    benchEmployeeName: string;
    benchEmployeeSubmissionId: string;
    clientName: string;

    orgId: string;

    interviewType: string;

    interviewStatus: string;

    scheduledDateTime: Date;
    feedBack: string;

    clientTimeStamp: string;

    firstVendorEmailAddress: string;
    firstVendorMobile: string;
    firstVendorName: string;
    primaryVendorEmailAddress: string;
    primaryVendorMobile: string;
    primaryVendorName: string;
    scheduledDateTimeEpoch: number;
    scheduledDateTimeToString: string;

}